export default __webpack_public_path__ + "static/media/rubygems.2600b819.svg";